import classes from "./Disclaimer.module.scss";

interface DisclaimerProps {
  translatedText: React.ReactNode;
  hasTopDivider?: boolean;
  hasBottomDivider?: boolean;
}

export const Disclaimer: React.FC<DisclaimerProps> = (props) => {
  const renderPaymentDisclaimer = () => {
    return !!props.translatedText ? (
      <>
        {props.hasTopDivider ? (
          <ft-divider class={classes.Divider}></ft-divider>
        ) : null}
        <p className={classes.Disclaimer}>{props.translatedText}</p>
        {props.hasBottomDivider ? (
          <ft-divider class={classes.Divider}></ft-divider>
        ) : null}
      </>
    ) : null;
  };

  return renderPaymentDisclaimer();
};
